var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderNumerici = function SvgLegendBuilderNumerici(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.045 16h1.782V8.954H5.04l-1.792 1.221v1.543l1.763-1.191h.034zm3.449-4.878v.034h1.641v-.034a.986.986 0 0 1 1.045-1 .863.863 0 0 1 .967.806c0 .439-.215.781-.8 1.343L8.6 14.8V16h5.368v-1.377h-3.042v-.034l1.684-1.553a3.2 3.2 0 0 0 1.27-2.163c0-1.235-1.04-2.095-2.642-2.095-1.645 0-2.744.952-2.744 2.344m8.489 1.895h.859c.684 0 1.1.332 1.1.879 0 .518-.439.874-1.079.874-.684 0-1.108-.337-1.138-.864h-1.71c.068 1.371 1.162 2.27 2.817 2.27 1.753 0 2.925-.835 2.925-2.129a1.69 1.69 0 0 0-1.724-1.69v-.039a1.647 1.647 0 0 0 1.467-1.626c0-1.162-1.03-1.914-2.6-1.914-1.636 0-2.725.894-2.749 2.251h1.622a.956.956 0 0 1 1.05-.918c.645 0 1.016.317 1.016.825s-.4.845-1 .845h-.856z",
    "data-name": "Path 5194"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderNumerici);
export default ForwardRef;